const masterEn = {
    country: require('lang/en/master/Country').default,
    state: require('lang/en/master/State').default,
    city: require('lang/en/master/City').default,
    category: require('lang/en/master/Category').default,
    unit: require('lang/en/master/Unit').default,
    pincode: require('lang/en/master/Pincode').default,
};

export default masterEn;